import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import React from 'react';

const ProductPricingContext = React.createContext<any>(undefined);
export default ProductPricingContext;